import { Address, Customer } from '@commercetools/platform-sdk';
import { validateEmail, validateName, validatePhoneNumber } from '@utils';
import { FormFields, FormState } from 'hooks';

export type CustomerInfoFormFieldNames = (
  'email' |
  'firstName' |
  'lastName' |
  'streetName' |
  'building' |
  'postalCode' |
  'city' |
  'state' |
  'phone'
);


export const getFormFields = (
  initialValues?: Partial<Address> | null
): FormFields<CustomerInfoFormFieldNames> => ({
  email: {
    name: 'email',
    initialValue: initialValues?.email ?? '',
    isRequired: true,
    validate: validateEmail,
    requiredMessage: 'Email is required'
  },
  firstName: {
    name: 'firstName',
    initialValue: initialValues?.firstName ?? '',
    isRequired: true,
    validate: validateName,
    requiredMessage: 'First name is required'
  },
  lastName: {
    name: 'lastName',
    initialValue: initialValues?.lastName ?? '',
    isRequired: true,
    validate: validateName,
    requiredMessage: 'Last name is required'
  },
  streetName: {
    name: 'streetName',
    initialValue: initialValues?.streetName ?? '',
    isRequired: true,
    requiredMessage: 'Address Line 1 is required'
  },
  building: {
    name: 'building',
    initialValue: initialValues?.building ?? ''
  },
  postalCode: {
    name: 'postalCode',
    initialValue: initialValues?.postalCode ?? '',
    isRequired: true,
    requiredMessage: 'Postal Code is required'
  },
  city: {
    name: 'city',
    initialValue: initialValues?.city ?? '',
    isRequired: true,
    validate: validateName,
    requiredMessage: 'City is required'
  },
  state: {
    name: 'state',
    isRequired: true,
    initialValue: initialValues?.state ?? '',
    requiredMessage: 'State is required'
  },
  phone: {
    name: 'phone',
    initialValue: initialValues?.phone ?? '',
    isRequired: true,
    validate: validatePhoneNumber,
    requiredMessage: 'Phone is required'
  }
});

export const mapCustomerToFormState = (customer: Customer): FormState<CustomerInfoFormFieldNames> | null => {
  if (customer.addresses?.length && customer.defaultShippingAddressId) {
    const defaultShippingAddress: Address | undefined = customer.addresses
      .find(address => address.id === customer.defaultShippingAddressId);

    if (defaultShippingAddress) {
      const {
        email = '',
        firstName = '',
        lastName = '',
        phone = '',
        streetName = '',
        building = '',
        state = '',
        city = '',
        postalCode = ''
      } = defaultShippingAddress;

      return ({
        email,
        firstName,
        lastName,
        phone,
        state,
        city,
        postalCode,
        streetName,
        building
      });
    }
  }

  return null;
};
